// src/i18n.js - VERSION CORRIGÉE AVEC NOUVELLES TRADUCTIONS

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// 🇫🇷 Correction des chemins d'importation pour correspondre à la structure src/locales/fr/translation.json
import translationFR from './locales/fr/translation.json'; 
// 🇬🇧 Correction des chemins d'importation pour correspondre à la structure src/locales/en/translation.json
import translationEN from './locales/en/translation.json';

const resources = {
    en: {
        translation: translationEN
    },
    fr: {
        translation: translationFR
    }
};

i18n
    .use(initReactI18next) // Ajoute les Hooks React (useTranslation, etc.)
    .init({
        resources,
        // Si vous souhaitez utiliser une détection de langue, vous pouvez l'ajouter ici
        // et remplacer 'fr' par la logique de détection
        lng: 'fr', // Langue par défaut
        fallbackLng: 'en', // Langue de secours
        
        // Clé pour le fichier de traduction dans les 'resources' (doit correspondre à 'translation')
        ns: ['translation'], 
        defaultNS: 'translation',

        interpolation: {
            escapeValue: false // Nécessaire pour React pour éviter l'échappement des valeurs
        },

        // ✅ AMÉLIORATION : Meilleure gestion des ressources manquantes
        saveMissing: true, // Enregistre les clés manquantes en développement
        missingKeyHandler: (lng, ns, key) => {
            console.warn(`🚨 Traduction manquante: [${lng}] ${key}`);
        }
    });

export default i18n;